 // Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyALzdd7qQdemxo4BHN--GRkLZ0GFlbEwLA",
  authDomain: "skillzaar-bcb0f.firebaseapp.com",
  projectId: "skillzaar-bcb0f",
  storageBucket: "skillzaar-bcb0f.firebasestorage.app",
  messagingSenderId: "18417914632",
  appId: "1:18417914632:web:9c08693103ccd713d892bd"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Firebase Auth instance
export const auth = getAuth(app);

export default app;